import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { FileText, Download } from "lucide-react";

export default function ResultPage() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/results").then((r) => setResults(r.data)).finally(() => setLoading(false));
  }, []);

  const link = (r) => {
    if (r.link_type === "file" && r.file_id) return fileUrl(r.file_id);
    if (r.link_type === "external" && r.external_link) return r.external_link;
    return null;
  };

  return (
    <div className="inner-page" data-testid="result-page">
      <h1 className="page-title">Result</h1>
      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th style={{ width: 60 }}>Sl. No.</th>
              <th>Title</th>
              <th style={{ width: 120 }}>Advt. No.</th>
              <th style={{ width: 120 }}>Date</th>
              <th style={{ width: 130 }}>Download</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} className="td-empty">Loading...</td></tr>}
            {!loading && results.length === 0 && <tr><td colSpan={5} className="td-empty">No results published yet.</td></tr>}
            {results.map((r, i) => {
              const href = link(r);
              return (
                <tr key={r.id} data-testid={`result-row-${i}`}>
                  <td>{i + 1}</td>
                  <td className="td-title"><FileText size={14} /> {r.title}{r.post ? ` (${r.post})` : ""}</td>
                  <td>{r.advt_no || "-"}</td>
                  <td>{r.date || "-"}</td>
                  <td>
                    {href ? (
                      <a href={href} target="_blank" rel="noreferrer" className="dl-btn" data-testid={`result-download-${i}`}>
                        <Download size={13} /> View
                      </a>
                    ) : (
                      <span className="muted">—</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
